<template>
  <main class="w-full">
    <BasePreloader loading width="100%" height="498px" preloader-class="mb-2" />
    <div class="mb-1 px-4">
      <BasePreloader loading width="100%" height="32px" />
    </div>
    <BasePreloader loading width="90%" height="32px" class="px-4" />
    <div class="my-4 flex items-center gap-4 px-4">
      <BasePreloader loading width="114px" height="16px" />
      <BasePreloader loading width="40px" height="16px" />
    </div>
    <div
      class="mb-6 px-4 flex flex-col gap-2 w-full md:w-full rounded-lg text-dark relative transition-200 group-hover:-translate-y-1"
    >
      <BasePreloader loading width="100%" height="24px" />
      <BasePreloader loading width="75%" height="24px" />
      <BasePreloader loading width="50%" height="24px" />
      <BasePreloader loading width="25%" height="24px" />
    </div>
    <div
      class="p-3 my-6 max-w-[682px] mx-auto flex flex-col gap-2 w-full md:w-full rounded-lg text-dark relative transition-200 group-hover:-translate-y-1"
    >
      <div v-for="(item, index) in 10" :key="index">
        <BasePreloader loading width="100%" height="24px" />
      </div>
    </div>
    <BasePreloader loading width="100%" height="498px" />
    <div
      class="p-3 my-6 max-w-[682px] mx-auto flex flex-col gap-2 w-full md:w-full rounded-lg text-dark relative transition-200 group-hover:-translate-y-1"
    >
      <div v-for="(item, index) in 10" :key="index">
        <BasePreloader loading width="100%" height="24px" />
      </div>
    </div>
  </main>
</template>
<script setup lang="ts">
import BasePreloader from "@/modules/Landing/components/Base/Preloader/Preloader.vue";
</script>
